import { Row, Col, Popconfirm } from "antd";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import { useEffect, useState } from "react";
import { useIndexedDBStore } from "use-indexeddb";
import {
  getTranslatedValue,
  successMsg,
  getMuiTheme,
  getDayNameAndDay,
} from "../../utils/Utils";
import {
  toDeleteAssessment,
  toGetListOfAssessmentUser,
} from "../../utils/APIs";
import { ThemeProvider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import ScreenLoader from "../../components/ScreenLoader";

const Forms = () => {
  const { getAll, add, deleteAll, deleteByID } =
    useIndexedDBStore("assessments");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    toGetListOfAssessmentUser()
      .then((res) => {
        deleteAll().then(() => {
          res.forEach((element) => {
            add(element);
          });
          getList();
        });
      })
      .catch((e) => {
        getList();
      });
  }, []);

  const getList = () => {
    getAll().then((res) => {
      var l__res = res.filter((el) => el.status == 2 || el.status == 3);
      setList(l__res.reverse());
      setLoading(false);
    });
  };

  const getId = (index) => {
    return list[index].id;
  };

  const toDelete = (id) => {
    toDeleteAssessment(id).then((res) => {
      if (res) {
        successMsg(getTranslatedValue("infoSaved"));
        deleteByID(id);
        getList();
      }
    });
  };

  const columns = [
    {
      field: "clinicName",
      headerName: getTranslatedValue("clinicName"),
      flex: 1,
      filterable: true,
      sortable: true,
    },
    {
      field: "doctorName",
      headerName: getTranslatedValue("doctorName"),
      flex: 1,
      filterable: true,
      sortable: true,
    },

    {
      field: "dt__created",
      headerName: getTranslatedValue("dateGenerationNoBR"),
      flex: 1,
      filterable: true,
      sortable: true,
      renderCell: (params) =>
        params.value != null ? (
          <span>{getDayNameAndDay(params.value)}</span>
        ) : (
          ""
        ),
    },
    {
      field: "edit",
      headerName: getTranslatedValue("edit"),
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      flex: 0.3,
      renderCell: (params) => (
        <div
          style={{
            margin: "auto",
            alignItems: "center",
          }}
        >
          <img
            style={{ width: "4vh" }}
            src="/images/icons/edit.svg"
            className="roi--cursor"
            alt="edit"
            onClick={() =>
              navigate("/tool", {
                state: { id: params.row.id },
              })
            }
          />
        </div>
      ),
    },
    {
      field: "delete",
      headerName: getTranslatedValue("delete"),
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      flex: 0.3,
      renderCell: (params) => (
        <Popconfirm
          title={<FormattedMessage id="deleteAssessment" />}
          onConfirm={() => toDelete(params.id)}
          okText={<FormattedMessage id="oui" />}
          cancelText={<FormattedMessage id="non" />}
          placement="left"
        >
          <img
            style={{ width: "4vh" }}
            src="/images/icons/quit.svg"
            className="roi--cursor"
            alt="delete"
          />
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      {loading && <ScreenLoader />}
      <HeaderUser />
      <div style={{ marginTop: "2vh" }}>
        <Row>
          <Col
            span={24}
            className="roi--settings-title"
            style={{ marginTop: "0.25vh", textAlign: "center" }}
          >
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="savedForm" />
            </span>
          </Col>
        </Row>
      </div>

      <div style={{ marginTop: "5vh" }}>
        <ThemeProvider theme={getMuiTheme()}>
          <DataGrid
            rows={list}
            columns={columns}
            getRowId={(row) => row.id}
            rowsPerPageOptions={[10, 30, 100]}
            pageSize={10}
            disableSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                color: "#54596E !important",
                fontSize: "20px !important",
                lineHeight: "20px !important",
                fontStyle: "normal !important",
                textTransform: "uppercase",
                fontFamily: "Gotham",
                textAlign: "center",
              },
              "& .MuiDataGrid-cell": {
                backgroundColor: "#F5F8FA",
                color: "#54596E",
                fontSize: "20px",
                lineHeight: "20px",
                fontStyle: "normal",
                fontWeight: "normal",
                fontFamily: "Gotham",
                textAlign: "center",
              },
            }}
          />
        </ThemeProvider>
      </div>

      {/* <Row style={{ marginTop: "4vh" }}>
        <Col span="2"></Col>
        <Col span="20">
          <Input
            prefix={<SearchOutlined />}
            placeholder={getTranslatedValue("search")}
            onInput={(e) => search(e)}
          />
        </Col>
        <Col span="2"></Col>
      </Row>
      <Row style={{ marginTop: "4vh" }}>
        <Col span="5" style={{ textAlign: "center" }}>
          <span className="roi--history-name">
            <FormattedMessage
              id="clinicNameSettings"
              values={{ roi__br: <br /> }}
            />
          </span>
        </Col>
        <Col span="5" style={{ textAlign: "center" }}>
          <span className="roi--history-name">
            <FormattedMessage
              id="doctorNameSettings"
              values={{ roi__br: <br /> }}
            />
          </span>
        </Col>
        <Col span="5" style={{ textAlign: "center" }}>
          <span className="roi--history-name">
            <FormattedMessage id="speciality" values={{ roi__br: <br /> }} />
          </span>
        </Col>
        <Col span="5" style={{ textAlign: "center" }}>
          <span className="roi--history-name">
            <FormattedMessage id="dateSaving" values={{ roi__br: <br /> }} />
          </span>
        </Col>
        <Col span="2">
          <span className="roi--forms-actions">
            <FormattedMessage id="edit" />
          </span>
        </Col>
        <Col span="2">
          <span className="roi--forms-actions">
            <FormattedMessage id="delete" />
          </span>
        </Col>
      </Row>

      {list.map((el) => (
        <Row style={{ marginTop: "2vh" }} className="roi--background-section ">
          <Col span="5" style={{ textAlign: "center", marginTop: "1.5vh" }}>
            <span className="roi--history-clinic-name ">{el.clinicName}</span>
          </Col>
          <Col span="5" style={{ textAlign: "center", marginTop: "1.5vh" }}>
            <span className="roi--history-clinic-name ">{el.doctorName}</span>
          </Col>
          <Col span="5" style={{ textAlign: "center", marginTop: "1.5vh" }}>
            <span className="roi--history-date">{el.speciality}</span>
          </Col>{" "}
          <Col span="5" style={{ textAlign: "center", marginTop: "1.5vh" }}>
            <span className="roi--history-date">{el.dateCreation}</span>
          </Col>
          <Col
            span={2}
            style={{
              margin: "auto",
              padding: "10px",
              alignItems: "center",
            }}
          >
            <img
              style={{ width: "4vh" }}
              src="/images/icons/edit.svg"
              className="roi--cursor"
              onClick={() =>
                navigate({
                  pathname: "/tool",
                  state: { id: el.id },
                })
              }
            />
          </Col>
          <Col
            span={2}
            style={{
              margin: "auto",
              padding: "10px",
              alignItems: "center",
            }}
          >
            <Popconfirm
              title={<FormattedMessage id="deleteAssessment" />}
              onConfirm={() => toDelete(el.id)}
              okText={<FormattedMessage id="oui" />}
              cancelText={<FormattedMessage id="non" />}
              placement="left"
            >
              <img
                style={{ width: "4vh" }}
                src="/images/icons/quit.svg"
                className="roi--cursor"
              />
            </Popconfirm>
          </Col>
        </Row>
      ))}
      <Row style={{ marginTop: "2vh" }}></Row> */}
    </>
  );
};
export default Forms;
